import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';
import { formatDate } from '../common/formatDate.js';
import GameTypeBadge from './GameTypeBadge.js';

export default function Game() {
  const { gameId } = useParams();
  const [game, setGame] = useState(undefined);
  const [player1, setPlayer1] = useState(undefined);
  const [player2, setPlayer2] = useState(undefined);

  useEffect(() => {
    getDoc(doc(db, 'games', gameId)).then(async snap => {
      if (!snap.exists()) {
        setGame(null);
        return;
      }
      const data = { id: snap.id, ...snap.data() };

      const [p1Snap, p2Snap] = await Promise.all([
        getDoc(doc(db, 'players', data.player1Id)),
        getDoc(doc(db, 'players', data.player2Id)),
      ]);

      setPlayer1(p1Snap.exists() ? { id: p1Snap.id, ...p1Snap.data() } : null);
      setPlayer2(p2Snap.exists() ? { id: p2Snap.id, ...p2Snap.data() } : null);
      setGame(data);
    });
  }, [gameId]);

  if (game === undefined || player1 === undefined || player2 === undefined) return <p>Loading…</p>;
  if (!game) return <p>Game not found.</p>;

  const isTie = game.player1Score === game.player2Score;
  const player1Won = game.player1Score > game.player2Score;
  const player2Won = game.player2Score > game.player1Score;

  return (
    <div className="w-100">
      <div className="mb-3">
        <Link to="/games">← All Games</Link>
      </div>

      <div className="panel">
        <div className="game-result-row">
          <div className={`text-center game-result-side ${player2Won ? 'game-loser' : ''}`}>
            <p className="game-result-name">
              {player1 ? <Link to={`/players/${player1.id}`}>{player1.name}</Link> : ''}
            </p>
            <p className="game-result-score">{game.player1Score}</p>
          </div>

          <div className="text-center game-result-final">
            <p className="mb-0">
              {isTie ? '' : <span className={player1Won ? 'game-arrow-visible' : 'game-arrow-hidden'}>← </span>}
              Final
              {isTie ? '' : <span className={player2Won ? 'game-arrow-visible' : 'game-arrow-hidden'}> →</span>}
            </p>
            <p className="text-muted mb-0">{isTie ? 'Tie' : ''}</p>
            <p className="text-muted recent-game-date mb-0">{formatDate(game.datePlayed)}</p>
            <p className="mb-0"><GameTypeBadge type={game.type} /></p>
          </div>

          <div className={`text-center game-result-side ${player1Won ? 'game-loser' : ''}`}>
            <p className="game-result-name">
              {player2 ? <Link to={`/players/${player2.id}`}>{player2.name}</Link> : ''}
            </p>
            <p className="game-result-score">{game.player2Score}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
